<template>
  <div id="landing">
    <section id="section__title">
      <v-row no-gutters class="landing-container">
        <top-header />
        <v-col cols="12" class="px-3">
          <p class="font--p-3 mb-1">주말 매출도, 배달 매출도!</p>
          <p class="font-size--30 font-weight-black">오늘 바로 입금되는 <br />선정산 서비스</p>
          <p class="font--m-4">
            오래 걸리는 매출 입금 <br />
            다음 날 빠르고 정확하게 땡겨드려요
          </p>
        </v-col>
        <v-col cols="12" class="mt-10 mb-5">
          <img src="@/assets/images/landing/SectionTitle/hand-money.png" class="hand" alt="hand" />
        </v-col>
        <v-col cols="12" class="text-center px-8">
          <v-btn block class="apply-btn" @click="goNext"> 번개입금 신청하기 </v-btn>
        </v-col>
      </v-row>
    </section>
    <section id="section__why">
      <v-row no-gutters class="landing-container" style="max-width: 414px">
        <v-col cols="1"></v-col>
        <v-col cols="11">
          <p class="ma-0 font--m-1">번개입금 서비스!</p>
        </v-col>

        <v-col cols="4"></v-col>
        <v-col cols="8">
          <p class="ma-0 font--m-1 text-center">
            <span class="font-size--35" style="color: #f45e4a">왜</span>
            써야 할까요?
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters class="landing-container">
        <v-col cols="12" class="mt-10">
          <p v-for="(comment, index) in comments" :key="`cm-${index}`" class="why-comment">
            <img src="@/assets/images/icons/check--pink.svg" />
            <span v-html="comment"></span>
          </p>
        </v-col>
      </v-row>

      <p class="text-center font--m-2 mb-0" style="line-height: 1.5; margin-top: 3rem">
        하루
        <span class="font--m-2 font-weight-black" style="color: #f45e4a">135원</span>
        <span class="font--m-5">(일 매출 50만원 기준)</span>
        으로 <br />
        바로 해결하세요!
      </p>
    </section>
    <section id="section__benefit" class="px-3">
      <v-row no-gutters class="text-center">
        <v-col cols="12">
          <p class="font--p-3">기다림도, 복잡한 정산도 없어집니다</p>
        </v-col>
        <v-col cols="12" class="mt-10">
          <div class="center-img">
            <img
              src="@/assets/images/landing/SectionBenefit/calendar.png"
              class="benefit"
              alt="calendar"
            />
            <span class="font--p-6">하루면 입금!</span>
            <p class="detail-info">카드도, 배달도 어제 매출 오늘 입금</p>
          </div>
        </v-col>
        <v-col cols="12" class="mt-10">
          <img
            src="@/assets/images/landing/SectionBenefit/schedule.png"
            class="benefit"
            alt="schedule"
          />
          <span class="font--p-6">365일 매출! 오전 정산!</span>
          <p class="detail-info">주말 매출도 기다림 없이</p>
        </v-col>
        <v-col cols="12" class="mt-10">
          <img
            src="@/assets/images/landing/SectionBenefit/circle.png"
            class="benefit"
            alt="circle"
          />
          <span class="font--p-6">정산 걱정 끝!</span>
          <p class="detail-info">복잡한 정산도 정확하고 빠르게</p>
        </v-col>
        <v-col cols="12" class="mt-10">
          <img
            src="@/assets/images/landing/SectionBenefit/price-down.png"
            class="benefit"
            alt="price-down"
          />
          <span class="font--p-6">이용료? 걱정마세요!</span>
          <p class="detail-info">국내 최저 수수료를 고집합니다</p>
        </v-col>
        <v-col cols="12" class="mt-10">
          <img src="@/assets/images/landing/SectionBenefit/dum.png" class="benefit" alt="dum" />
          <span class="font--p-6">내일 매출 당겨받기는 덤!!</span>
          <p class="detail-info">한 달 평균 매출의 1~5일 매출을 미리 드립니다.</p>
        </v-col>
      </v-row>
    </section>
    <section id="section__process2" class="px-3">
      <v-row no-gutters class="landing-container">
        <v-col cols="12" class="mb-10">
          <span class="font--m-5">복잡한 정산주기 신경 쓰지 마세요</span>
          <p class="font--p-3">그냥 오늘 받으세요</p>
        </v-col>
        <div class="card-img">
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/bc카드.png" alt="point" />
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <img
              class="mb-1"
              src="@/assets/images/landing/SectionProcess/현대카드.png"
              alt="point"
            />
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/국민카드.png" alt="point" />
          </v-col>
        </div>
        <div class="card-img">
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/하나카드.png" alt="point" />
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/삼성카드.png" alt="point" />
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/롯데카드.png" alt="point" />
          </v-col>
        </div>
        <div class="card-img">
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/신한카드.png" alt="point" />
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/농협카드.png" alt="point" />
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/우리카드.png" alt="point" />
          </v-col>
        </div>
        <div class="card-img">
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/baemin.png" alt="point" />
          </v-col>
          <v-col cols="4" class="ma-0 pa-0">
            <img src="@/assets/images/landing/SectionProcess/yogiyo.png" alt="point" />
          </v-col>
        </div>
        <v-col cols="12" class="mt-15">
          <p class="font--m-9">
            국내 1위 <strong>나이스정보통신</strong>과 <strong>펀다에이아이</strong>가 공동 제공하는
            번개입금은 9개 카드사 + 배달 3사 매출을 모두 즉시 정산해드립니다.
          </p>
        </v-col>
      </v-row>
    </section>

    <section id="section__fee" class="px-3">
      <v-row no-gutters class="landing-container">
        <v-col cols="12" class="mb-5">
          <p class="font--p-5 font-weight-black mb-2">이용 수수료</p>
          <p class="font--m-6">
            이용 수수료는 일 선정산 금액의
            <span style="color: #ff5656">0.027%</span> 로 <br />
            가장 저렴하게 제공해 드리고 있어요
          </p>
        </v-col>

        <v-col cols="12" class="mb-10">
          <p class="font--p-2 text-center">
            일 {{ parseInt(amounts[value] * 0.0002685) | commaFormat }} 원
          </p>
        </v-col>

        <v-col class="pr-4 mt-2">
          <v-slider
            v-model="value"
            color="gray"
            track-color="gray"
            class="align-center"
            min="0"
            max="5"
            thumb-color="black"
            :thumb-size="50"
            thumb-label="always"
          >
            <template v-slot:thumb-label="{ value }">
              <div class="text-center">
                일매출 <br />{{ (amounts[value] / 10000) | commaFormat }}만
              </div>
            </template>
          </v-slider>
        </v-col>

        <v-col cols="12" class="mt-10 text-center px-8">
          <v-btn block class="apply-btn" @click="goNext"> 번개입금 신청하기 </v-btn>
        </v-col>
      </v-row>
    </section>
    <section id="section__review" class="px-3">
      <v-row no-gutters class="landing-container px-3">
        <v-col v-for="(review, i) in reviews" :key="i" cols="12" class="review-box">
          <p class="color--white font--p-6 mb-2">"{{ review.text }}"</p>

          <div class="d-flex align-center">
            <v-avatar v-if="false" size="50" color="white" class="mr-3"> </v-avatar>
            <p class="font--m-6 color--white mb-0">- {{ review.store }} {{ review.name }} 사장님</p>
          </div>
        </v-col>
      </v-row>
    </section>
    <section id="section__money" class="px-3">
      <v-row no-gutters class="landing-container text-center">
        <v-col cols="12">
          <p class="font--p-5">현명한 선택에 지금 참여하세요!</p>
        </v-col>
        <template v-for="(item, i) in money">
          <v-col cols="12" class="text-right mt-10" :key="i">
            <span class="font-size--35 font-weight-black">{{ item.won }}</span>
            <p class="font--m-5">{{ item.text }}</p>
          </v-col>
        </template>

        <v-col cols="12" class="mt-5 text-center px-8">
          <v-btn block class="apply-btn" @click="goNext"> 번개입금 신청하기 </v-btn>
        </v-col>
      </v-row>
    </section>
    <v-dialog v-model="show" persistent max-width="768px">
      <v-card>
        <v-card-title class="px-2 pt-5">
          <p class="ma-0 font-weight-bold">연락드릴 정보를 알려주세요</p>
        </v-card-title>

        <v-card-text class="mt-2 mb-3 px-2">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field v-model="callbackRequest.name" label="이름" outlined></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="callbackRequest.phone"
                label="연락처"
                hide-details
                type="tel"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pa-0">
          <v-row no-gutters>
            <v-col cols="12">
              <BasicButton :loading="isLoading" :disabled="!isValid" @click="send(callbackRequest)">
                확인
              </BasicButton>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SectionFooter />
  </div>
</template>

<script>
import TopHeader from '@/components/common/layout/TopHeader.vue'
import SectionFooter from '@/components/landing/SectionFooter.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    TopHeader,
    SectionFooter,
  },
  computed: {
    isValid() {
      if (this.isLoading) {
        return false
      }

      return !!this.callbackRequest.name && !!this.callbackRequest.phone
    },
  },
  data() {
    return {
      isLoading: false,
      callbackRequest: {
        name: null,
        phone: null,
        serviceType: 'early_payment',
        sourceUrl: null,
        extra: null,
      },
      show: false,
      comments: [
        '내 카드 매출, 배달 매출을 왜 늦게 받아야 하지?',
        '주말 매출도 바로 받을 수는 없을까?',
      ],
      amounts: [0, 300000, 500000, 1000000, 1500000, 2000000],
      value: 2,
      reviews: [
        {
          text: '타사의 선정산 서비스를 이용해 봤는데 번개입금 서비스는 타사의 절반도 안되는 비용으로 이용이 가능해서 주위에 추천하고 있어요',
          name: '김*영',
          store: 'xx 돼지국밥',
        },
        {
          text: '장사가 잘되는 날엔 기분은 좋지만 다음 날 재료비 고민이 많았는데 번개입금 서비스로 고민이 해결 됐어요',
          name: '박*영',
          store: 'xx 해장국',
        },
        {
          text: '배달 매출 늦게 들어오는 고민이 싹 해결되었어요',
          name: '최*호',
          store: 'xx 치킨',
        },
        {
          text: '카드 매출 뿐만 아니라 배달 매출까지 정확하게 정산 되니 너무 편해요',
          name: '이*수',
          store: 'xxx 식당',
        },
      ],
      money: [
        {
          text: '누적 정산 금액',
          won: '578억원',
        },
        {
          text: '이용자 재이용률',
          won: '98%',
        },
        {
          text: '매일 신청자 수',
          won: '1,560명',
        },
        {
          text: '고객 만족도',
          won: '9.7/10.0',
        },
      ],
    }
  },
  methods: {
    ...mapActions('earlyPayment', ['addEarlyPaymentsCallbackRequests']),
    async goNext() {
      this.show = true
    },
    async send(callbackRequest) {
      try {
        this.isLoading = true
        this.show = true
        await this.addEarlyPaymentsCallbackRequests({
          ...callbackRequest,
          sourceUrl: location.href,
        })
        await this.$swal.basic.alert({
          html: `담당 매니저가 곧 연락 드릴게요!`,
        })
        this.show = false
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

#landing {
  .bottom-button {
    position: fixed;
    display: flex;
    bottom: 30px;
    max-width: 720px;
    width: 80vw;
    // z-index: 1000;
    left: 50%;
    transform: translateX(-50%);

    button.btn-kakao {
      border-radius: 32px;
      box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.14);
      &:hover {
        color: white !important;
        background-color: #333333 !important;
      }
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  :deep(section) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  :deep(.landing-container) {
    max-width: $standard-max-width;
    margin: 0 auto;
  }
}
#section__title {
  .hand {
    width: 100%;
    height: 230px;
    object-fit: contain;
  }

  .apply-btn {
    background-color: #004953;
    color: white;
    height: 50px;
    font-size: 20px;
  }
}
#section__why {
  background-color: white;
  padding: 5rem 12px !important;

  .why-comment {
    background-color: #f3f3f3;
    border-radius: 8px;
    font-weight: bold;

    margin-bottom: 35px;
    padding: 8px 12px;

    img {
      width: 22px;
      object-fit: contain;
      padding-right: 8px;
    }

    span {
      font-size: 15px;
    }
  }
}

#section__benefit {
  .benefit {
    width: 100%;
    height: 110px;
    object-fit: contain;
  }

  .detail-info {
    font-size: 0.9rem;
    color: #333333;
  }
}

#section__process2 {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  background-color: #ffffff;

  .point {
    color: #14afff;
  }

  .card-img {
    display: flex !important;
    position: relative;
    width: 100%;
    img {
      max-width: 90%;
      object-fit: contain;
      height: 70px;
    }
  }
}

#section__fee {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  background-color: #eef6fa;

  .apply-btn {
    background-color: #d30000;
    color: white;
    height: 50px;
    font-size: 20px;
  }
}

#section__review {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  background-color: #4a4a4a;

  .apply-btn {
    background-color: #d30000;
    color: white;
    width: 80%;
    height: 50px;
    font-size: 18px;
  }

  .review-box:not(:last-child) {
    margin-bottom: 3rem;
  }
}

#section__money {
  background-color: #ffffff;
  display: flex !important;
  flex-direction: column;
  overflow: hidden;

  .apply-btn {
    background-color: #82d4fe;
    height: 50px;
    font-size: 20px;
  }
}
</style>
